<template>
  <div class="modal-overlay" @click="close">
    <div class="modal-status-container" @click.stop v-if="step === 1">
      <div class="modal-status-header">
        <div style="cursor: pointer;" @click="close">
          <Close color="#71767D" />
        </div>
      </div>
      <div class="modal-status-content">
        <h1>{{ __(`Deseja excluir o ${title.toLowerCase()}?`) }}</h1>
        <div class="vinculed-container">
          <h2>{{ __(title) }}: <span>{{ currentStatus.name }}</span></h2>
          <p>{{ __(`Esse ${title.toLowerCase()} está vinculado a`) }}:</p>
          <ul v-if="usage.length">
            <li
              v-for="item in usage"
            >
              {{ __(item.entity) }}
              <span>{{ item.count }}</span>
            </li>
          </ul>
          <i v-else class="fa fa-circle-o-notch fa-spin"></i>
        </div>
        <div v-if="statusOcurrences > 0" class="substitute-container">
          <p>{{ __('Substituir') }} "{{ currentStatus.name }}" {{ __('por:') }} </p>
          <Multiselect
            label="name"
            track-by="id"
            :placeholder="__(`Digite o nome do ${title.toLowerCase()}`)"
            :options="statusesWithoutCurrentStatus"
            v-model="replacementStatus"
            :searchable="true"
            :show-labels="false"
            openDirection="bottom"
          >
            <template slot="caret">
              <span class="search-icon-origin">
                <img
                  src="/build/icons/search-icon.svg"
                  width="16"
                  height="16"
                  alt="Lupa do campo de pesquisa"
                  class="position-absolute filter-user-icon"
                />
              </span>
            </template>
            <template slot="noResult">
              <span class="no-results">
                {{ __(`Nenhum ${title.toLowerCase()} encontrado com esse nome`) }}
              </span>
            </template>
            <template slot="noOptions">{{ __(`Nenhum ${title.toLowerCase()} encontrado`) }}</template>
          </Multiselect>
          <p v-if="error" class="error-text">{{ __(`Selecione um novo ${title.toLowerCase()} para os itens vinculados.`) }}</p>
        </div>

        <div class="btn-container">
          <button @click="nextStep" :disabled="loading" class="btn-continue">
            <p v-if="!deletingStatus">{{ __('Concluir') }}</p>
            <p v-else>{{ __('Concluindo') }}...</p>
          </button>
          <button @click="close" :disabled="deletingStatus" class="btn-cancel">
            {{ __('Cancelar') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Close from '../../../js/components/icon/Close.vue'

export default {
  props: {
    statuses: {
      type: Array,
      default: []
    },
    currentStatus: {
      type: Object,
      default: {}
    },
    type: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
  },

  components: {
    Close
  },

  data() {
    return {
      step: 1,
      isDeleteModalOpen: false,
      replacementStatus: null,
      usage: [],
      loading: false,
      deletingStatus: false,
      error: false,
    }
  },

  computed: {
    statusesWithoutCurrentStatus() {
      const filteredStatuses = this.statuses.filter(status => status.name !== this.currentStatus.name);
      return filteredStatuses;
    },

    statusOcurrences() {
      return this.usage.reduce((acc, item) => acc + item.count, 0);
    },
  },

  created() {
    this.getStatusUsage();
  },

  methods: {
    close() {
      if(this.deletingStatus) return;
      this.step = 1;
      this.replacementStatus = null;
      this.$emit('close-modal');
    },

    getStatusUsage() {
      this.loading = true;
      const { id } = this.currentStatus;
      const type = this.type;
      this.$http.get(`settings/status/${id}/usage`, {
        params: { type }
        })
        .then((response) => {
          const data = response.body;
          const entities = Object.keys(data);
          const usage = entities.map(entity => ({
            entity: this.entityTranslator(entity),
            count: data[entity].count
          }));
          this.usage = usage;
        })
        .catch((error) => Alert.error(this.__('Erro ao carregar ocorrências desse status.')))
        .finally(() => this.loading = false)
    },

    nextStep() {
      if(this.statusOcurrences <= 0) {
        this.deleteStatus(false);
      }

      if(this.statusOcurrences > 0) {
        if(!this.replacementStatus) {
          this.error = true;
        } else {
          this.deleteStatus(true);
        }
      }
    },

    deleteStatus(hasOcurrences) {
      this.deletingStatus = true;
      const { id, order } = this.currentStatus;

      const attemptReplace = () => {
        if (hasOcurrences) {
          return this.$http.put(
            `settings/status/${id}/replace/${this.replacementStatus.id}/type/status?order=${order}`
          );
        }
        return Promise.resolve();
      };

      attemptReplace()
        .then(() => {
          this.$http
            .delete(`settings/status/${id}`, { params: { type: this.type } })
            .then(() => {
              this.$emit("remove-status", this.currentStatus);
              Alert.success(this.__("Excluído com sucesso!"));
            })
            .catch(({ data }) => {
              const message = data.message || data.error || __("Erro ao excluir!");
              Alert.error(message);
            })
            .finally(() => {
              this.deletingStatus = false;
              this.close();
            });
        })
        .catch(() => {
          if (this.type === "lead") {
            Alert.error(this.__("Erro ao substituir status!"));
          } else {
            Alert.error(this.__("Erro ao substituir motivo!"));
          }
          this.deletingStatus = false;
        });
    },

    entityTranslator(entity) {
      switch (entity) {
        case 'deals': return 'Negócios';
        case 'leads': return 'Leads';
        case 'segments': return 'Segmentação';
        case 'automations': return 'Campanhas';
        default: return entity;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../sass/_variables.scss';
@import '../../../sass/_mixins.scss';

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1051;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-status-container {
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  background: $salesflow-background-content;
  box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.10);
  z-index: 1050;
  width: 540px;
  animation: scaleIn 0.3s;
}

.modal-status-container-2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 16px;
  padding: 56px 48px;
  background: $salesflow-background-content;
  box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.10);
  z-index: 1050;
  width: 332px;
  animation: scaleIn 0.3s;

  h1 {
    color: $salesflow-font-gray;
    text-align: center;
    font-family: 'Montserrat';
    font-size: 16px;
    font-weight: 700;
    line-height: 150%;
    width: 100%;
    margin-top: 24px;
    margin-bottom: 48px;
  }

  button {
    display: flex;
    padding: 12px 32px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 14px;
    border: 1px solid $salesflow-secondary;
    background: $salesflow-secondary;
    color: $salesflow-font-dark;
    font-family: 'Montserrat';
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
  }

  button:hover {
    border: 1px solid $salesflow-secondary-hover;
    background-color: $salesflow-secondary-hover;
    color: #FFFFFF;
  }
}

.modal-status-header {
  display: flex;
  padding: 16px 24px;
  border-radius: 16px;
  justify-content: flex-end;
  align-items: center;
  height: 48px;
  background: $salesflow-background-content;
  z-index: 1050;
  border: none;
}

.modal-status-content {
  border: none;
  width: 540px;
  border-radius: 16px;
  padding: 0 80px 40px 80px;
  background: $salesflow-background-content;
  z-index: 1050;
  display: flex;
  flex-direction: column;
  gap: 24px;

  h1 {
    color: $salesflow-font-gray;
    text-align: center;
    font-family: 'Montserrat';
    font-size: 28px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    margin-bottom: 0;
  }

  h2 {
    color: #242424;
    font-family: 'Montserrat';
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    overflow: hidden;
    white-space: nowrap;
    max-width: 100%;
    text-overflow: ellipsis;

    span {
      color: $salesflow-font-gray;
    }
  }

  p {
    color: $salesflow-font-dark;
    font-family: 'Montserrat';
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    margin-bottom: 8px;
  }

  .error-text {
    color: $salesflow-info;
    font-family: 'Montserrat';
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    margin-top: 4px;
  }
}

.vinculed-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ul {
    list-style-type: none;
    width: 100%;
    padding: 0;
    margin: 0;

    li {
      font-family: 'Montserrat';
      font-weight: 500;
      color: $salesflow-font-gray;
      line-height: 150%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 16px;
      border: 1px solid $salesflow-outline-gray-medium;
      border-bottom: none;
      background: #FFF;

      &:first-child {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
      }

      &:last-child {
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        border-bottom: 1px solid $salesflow-outline-gray-medium;
      }
    }
  }
}

.substitute-container {
  ::v-deep {
    button.dropdown-toggle {
      .btn {
        border: 1px solid $salesflow-outline-gray-light;
        padding: 0.625rem 0.75rem;
        border-radius: 12px;
        height: 45px;
      }

      .value {
        @include salesflow-subtitle($color: $salesflow-font-dark);
        font-family: 'Inter';

        &.placeholder {
          @include salesflow-subtitle($color: $salesflow-font-gray-light);
          font-family: 'Inter';
          font-weight: 300;
          line-height: 150%;
        }
      }
    }

    .btn-group {
      width: 100%;
      border-radius: 12px;
      background: #FFF;
    }

    .value.placeholder {
      color: $salesflow-font-gray-light;
      font-family: 'Inter';
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
    }

    .dropdown-menu {
      top: 6px !important;
      max-height: 216px;
      border-color: $salesflow-outline-gray-light;
    }

    .dropdown-item:hover {
      background-color: $salesflow-purple-extra-light;
    }
  }
}

.btn-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 24px;

  .btn-continue {
    display: flex;
    padding: 10px 24px;
    min-width: 149px;
    height: 50px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 14px;
    border: 1px solid $salesflow-secondary;
    background: $salesflow-secondary;
    margin-bottom: 16px;

    p {
      color: $salesflow-font-dark;
      font-family: 'Montserrat';
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 150%;
      margin: 0;
    }
  }

  .btn-continue:hover:enabled {
    border: 1px solid $salesflow-secondary-hover;
    background-color: $salesflow-secondary-hover;

    p {
      color: #FFFFFF;
    }
  }

  .btn-continue:disabled {
    cursor: not-allowed;
  }

  .btn-cancel {
    border: none;
    background: none;
    color: $salesflow-font-gray;
    text-align: center;
    font-family: 'Montserrat';
    font-size: 12px;
    font-weight: 600;
    line-height: 150%;
    cursor: pointer;
    text-decoration-line: underline;
  }

  .btn-cancel:hover:enabled {
    color: $salesflow-primary-hover;
  }

  .btn-cancel:disabled {
    cursor: default;
  }
}

@keyframes scaleIn {
  from { transform: scale(0.7); }
  to { transform: scale(1); }
}

::v-deep .multiselect {
  width: 100%;
  height: 54px;
  border: 1px solid $salesflow-outline-gray-medium;
  border-radius: 12px;
  background-color: #FFF;
}

::v-deep .multiselect--active {
  border-radius: 12px;
  border-bottom-left-radius: 12px !important;
  border-bottom-right-radius: 12px !important;
}

::v-deep .multiselect__input {
  width: 100%;
  height: 54px;
  border-radius: 12px;
  border-bottom-left-radius: 12px !important;
  border-bottom-right-radius: 12px !important;

  &::placeholder {
    color: transparent !important;
    opacity: 0 !important;
  }
}

::v-deep .multiselect__placeholder {
  font-family: 'Montserrat';
  color: $salesflow-font-gray-light;
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
  position: relative;
  margin: 0;
  padding: 18px 16px 17px;
}

::v-deep .multiselect__tag {
  border-radius: 12px;
  width: 113px;
  height: 20px;
  color:$salesflow-font-dark;
  margin: 0px;
  font-size: 12px;
}

::v-deep .multiselect__tags {
  height: fit-content;
}

::v-deep .multiselect__tag-icon:hover {
  background-color: $salesflow-purple-extra-light;
}

::v-deep .multiselect__tag-icon:after {
  color:$salesflow-outline-gray;
  font-size: 26px;
  width: 7.5px;
  height: 7.5px;
  font-weight: 100;
  position: absolute;
  bottom: 15px;
  right: 8px;
  left: 1.25px;
  top: -0.75px;
}

::v-deep .multiselect__content {
  background-color: $white;
  font-family: 'Inter';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: $salesflow-purple-extra-dark;
}

::v-deep .multiselect__tags-wrap {
  width: 100%;
  flex-wrap: wrap;
  gap: 8px;
  display: flex;
}

::v-deep .multiselect__content-wrapper {
  background-color: $white;
  position: fixed;
  width: 380px;
  max-height: 380px;
  border-radius: 14px;
  box-shadow: none;
  border: 1px solid $salesflow-outline-gray-medium;
  border-top: 1px solid $salesflow-outline-gray-medium;
}

::v-deep .multiselect__content-wrapper:before {
  border-bottom: $white;
}

::v-deep .multiselect__option {
  color: $salesflow-font-dark;
  font-family: 'Inter';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  padding: 4px 16px;
  background: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  max-width: 100%;
  min-height: auto;

  &:hover:not(.multiselect__option--selected) {
    background: $salesflow-outline-gray-medium;
  }
}

::v-deep .multiselect__single {
  font-family: 'Inter';
  line-height: 150%;
  height: 54px;
  margin-bottom: 0px;
  padding: 15px 20px;
  border-radius: 14px;
  max-width: 90%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.search-icon-origin {
  position: absolute;
  top: 19px;
  right: 28px;
  z-index: 5;
}

.no-results {
  color: $salesflow-font-gray;
}

@media only screen and (max-width: 991px) {
  ::v-deep .multiselect__content-wrapper {
    width: 380px !important;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1280px) {
  ::v-deep .multiselect__content-wrapper {
    width: 380px !important;
  }
}
</style>
